/**
 * Instant hover tips for the dashboard tile buttons (.dash-tile-btn). A native
 * `title` waits about a second, so the buttons carry their text in
 * `aria-label` and this one fixed-position tip shows it at once. It lives on
 * <body> because the tile card clips its overflow.
 */
const SELECTOR = '.dash-tile-btn[aria-label]';
let tip: HTMLDivElement | null = null;
let anchor: HTMLElement | null = null;

function show(btn: HTMLElement): void {
  anchor = btn;
  if (!tip) {
    tip = document.createElement('div');
    tip.className = 'dash-tip';
    tip.setAttribute('aria-hidden', 'true'); // the button's own aria-label is what assistive tech reads
    document.body.append(tip);
  }
  tip.textContent = btn.getAttribute('aria-label');
  tip.hidden = false;
  const b = btn.getBoundingClientRect();
  const t = tip.getBoundingClientRect();
  const left = Math.min(Math.max(8, b.right - t.width), window.innerWidth - t.width - 8);
  const below = b.bottom + 6;
  const top = below + t.height > window.innerHeight - 8 ? b.top - t.height - 6 : below;
  tip.style.left = `${left}px`;
  tip.style.top = `${top}px`;
}

function hide(): void {
  anchor = null;
  if (tip) tip.hidden = true;
}

document.addEventListener('pointerover', (e) => {
  if (e.pointerType === 'touch') return;
  const btn = (e.target as Element).closest?.<HTMLElement>(SELECTOR);
  if (btn) show(btn);
  else if (anchor) hide();
});
document.addEventListener('focusin', (e) => {
  const btn = (e.target as Element).closest?.<HTMLElement>(SELECTOR);
  if (btn && btn.matches(':focus-visible')) show(btn);
});
document.addEventListener('focusout', hide);
document.addEventListener('scroll', hide, true);
// A click can change the label (the slicer toggle) or remove the button.
document.addEventListener('click', () => {
  requestAnimationFrame(() => {
    if (anchor?.isConnected && anchor.matches(':hover, :focus-visible')) show(anchor);
    else hide();
  });
});
